import {
  ActionsObservable,
  StateObservable,
  ofType,
  combineEpics,
} from 'redux-observable';
import { RootAction, RootState } from '@src/app/_redux';
import { ApiClient } from '@src/app/_global/utility/apiUtils';
import { ApiConfig } from '@src/app/_global/domain';
import {
  config as AWSConfig,
  CognitoIdentityCredentials,
} from 'aws-sdk/global';
import { EVENTBUS_PUBLISH } from '@src/app/eventLogging';
import { mergeMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

const EVENTBUSTRANSACTIONTYPE = 'eventBusTransactionType';
const EVENTBUSPOSTBODY = 'eventBusPostBody';

const publishEvent = (
  action$: ActionsObservable<RootAction>,
  state$: StateObservable<RootState>,
) =>
  action$.pipe(
    ofType(EVENTBUS_PUBLISH),
    mergeMap(({ payload }) => {
      const clientConfig = state$.value.clientConfig.clientConfig;
      if (state$.value.auth.omsAuth.credentials) {
        AWSConfig.credentials = new CognitoIdentityCredentials(
          state$.value.auth.omsAuth.credentials,
        );
      } else {
        const credentialsObject = {
          IdentityPoolId: clientConfig.identityPoolId,
          IdentityId: payload.IdentityId,
        };
        AWSConfig.credentials = new CognitoIdentityCredentials(credentialsObject);
      }
      
      let newPayload = {};
      let newEventData = {
        'category': payload.category,
        'action': payload.action,
        'label': payload.label ? payload.label : '',
        'value': payload.value ? payload.value : ''
      };
      newPayload[EVENTBUSTRANSACTIONTYPE] = 'PUBLISH';
      newPayload[EVENTBUSPOSTBODY] = newEventData;
      const client = new ApiClient();
      if (!AWSConfig.region) {
        AWSConfig.region = clientConfig.Region;
      }
      const apiConfig: ApiConfig = {
        creds: AWSConfig.credentials as CognitoIdentityCredentials,
        url: clientConfig.url,
        path: '/eventbuspublish',
        region: clientConfig.Region,
        requestmethod: 'POST',
        requestbody: newPayload,
        parms: {},
        additionalParms: {
          headers: {
            'x-session-id': clientConfig.uuid
          },
        },
      };
      client.callApiGateway(apiConfig);

      return EMPTY;
    }),
  );

export const epics = combineEpics(publishEvent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/eventLogging/epics.ts